module.exports = {
  // 暂不支持 ./
  publicPath: "/icbc/icbc_gdn/",
  // 是否开启cdn 默认 关闭
  isOpenCDN: true,
};
